// =============================
// File: src/components/user/ReferralStats.jsx
// =============================
import React from 'react';
import { Users, TrendingUp } from 'lucide-react';

function ReferralStats({ summary }) {
  const stats = [
    {
      icon: Users,
      label: 'Referidos Activos',
      value: summary?.total_active_referrals || 0,
      color: 'text-brand-primary',
      bgColor: 'bg-brand-primary/10'
    },
    {
      icon: TrendingUp,
      label: 'Ganancia Total',
      value: `S/ ${summary?.total_lifetime_earnings?.toFixed(2) || '0.00'}`,
      color: 'text-brand-green',
      bgColor: 'bg-brand-green/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 gap-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between mb-2">
              <div className={`w-10 h-10 ${stat.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon className={`w-5 h-5 ${stat.color}`} />
              </div>
            </div>
            <p className="text-2xl font-extrabold font-montserrat text-slate-800 mb-1">
              {stat.value}
            </p>
            <p className="text-xs font-medium font-montserrat text-slate-500">
              {stat.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default ReferralStats;